import { compareDesc, parseISO } from 'date-fns'
import { Log } from '@/types/logs'

export const reorderLinkedLogs = (logs: Log[]): Log[] => {
    const result: Log[] = []
    const pending: { [id: string]: Log[] } = {}

    logs.forEach((log) => {
        if (!log.eventLog) {
            result.push(log)
        } else {
            pending[log.eventLog.id] = [...(pending[log.eventLog.id] || []), log]
        }
    })

    Object.keys(pending).forEach((logId) => {
        const logIndex = result.findIndex((item) => item.id === logId)

        if (logIndex === -1) {
            return
        }

        const toInsert = pending[logId]
        toInsert.sort((a, b) => compareDesc(parseISO(a.timestamp), parseISO(b.timestamp)))
        result.splice(logIndex + 1, 0, ...toInsert)
    })

    return result
}
